import { json, postBiz } from '../core/coreapi';

import {
  BudgetControlAllocationSaveItem,
  BudgetControlSaveResult,
  BudgetControlWorkbenchModel,
} from './budgetcontrol.models';

import {
  normalizeBudgetControlSaveResult,
  normalizeBudgetControlWorkbench,
} from './budgetcontrol.normalizers';

const SERVICE = 'budgetcontrol';

export async function getBudgetControlWorkbench(
  planningCycleId: number
): Promise<BudgetControlWorkbenchModel> {
  const response = await postBiz({
    s: SERVICE,
    a: 'workbench',
    pci: planningCycleId,
  });
  return normalizeBudgetControlWorkbench(json(response));
}

export async function createBudgetControl(payload: {
  planningCycleId: number;
  capacityAmount: number;
  currencyCode?: string;
  name?: string;
  sourceScenarioId?: number | null;
}): Promise<BudgetControlSaveResult> {
  const response = await postBiz({
    s: SERVICE,
    a: 'create',
    pci: payload.planningCycleId,
    cap: payload.capacityAmount,
    cur: payload.currencyCode || 'XOF',
    nam: payload.name || '',
    ssi: payload.sourceScenarioId ?? null,
  });
  return normalizeBudgetControlSaveResult(json(response));
}

export async function saveBudgetControlAllocations(
  id: number,
  stamp: string,
  allocations: BudgetControlAllocationSaveItem[]
): Promise<BudgetControlSaveResult> {
  const response = await postBiz({
    s: SERVICE,
    a: 'allocationsave',
    rid: id,
    stp: stamp,
    als: allocations.map((x) => ({
      controlareacode: x.controlAreaCode,
      allocationpercent: x.allocationPercent,
      warningpercent: x.warningPercent,
      reason: x.reason ?? null,
      remarks: x.remarks ?? null,
    })),
  });
  return normalizeBudgetControlSaveResult(json(response));
}

// async function transition(
//   action: 'review' | 'activate',
//   id: number,
//   stamp: string,
//   remarks?: string | null
// ) {
//   const response = await postBiz({
//     s: SERVICE,
//     a,
//     rid: id,
//     stp: stamp,
//     rmk: remarks || null,
//   });
//   return normalizeBudgetControlSaveResult(json(response));
// }

export async function reviewBudgetControl(
  id: number,
  stamp: string,
  remarks?: string | null
) {
  const response = await postBiz({
    s: SERVICE,
    a: 'review',
    rid: id,
    stp: stamp,
    rmk: remarks || null,
  });
  return normalizeBudgetControlSaveResult(json(response));
}// => transition('review', id, stamp, remarks);

export async function activateBudgetControl (
  id: number,
  stamp: string,
  remarks?: string | null
) {
  const response = await postBiz({
    s: SERVICE,
    a: 'activate',
    rid: id,
    stp: stamp,
    rmk: remarks || null,
  });
  return normalizeBudgetControlSaveResult(json(response));
}// => transition('activate', id, stamp, remarks);

export async function reviseBudgetControl(
  id: number,
  capacityAmount?: number | null,
  reason?: string | null
) {
  const response = await postBiz({
    s: SERVICE,
    a: 'revise',
    sid: id,
    cap: capacityAmount ?? null,
    rsn: reason ?? null,
  });
  return normalizeBudgetControlSaveResult(json(response));
}

export async function completeBudgetControl(
  planningCycleId: number,
  notes?: string | null
): Promise<any> {
  const response = await postBiz({
    s: SERVICE,
    a: 'complete',
    pci: planningCycleId,
    nts: notes ?? '',
  });
  return json(response);
}
